import { render, staticRenderFns } from "./SymptomInvestigationTable.vue?vue&type=template&id=495950b6&scoped=true"
import script from "./SymptomInvestigationTable.vue?vue&type=script&lang=js"
export * from "./SymptomInvestigationTable.vue?vue&type=script&lang=js"
import style0 from "./SymptomInvestigationTable.vue?vue&type=style&index=0&id=495950b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495950b6",
  null
  
)

export default component.exports